import React from 'react';
import { Typography, Button, Divider } from '@material-ui/core';
import { Radio, RadioGroup, FormControlLabel, FormControl } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

function FourthStep(props) {
    const { values } = props;
    var clickCount = 0;
    const next = (event) => {
        event.preventDefault();
        props.handleChange(event);
        clickCount++;
        if (clickCount < 2) {
            setTimeout(() => {
                if (clickCount <= 1) {
                    props.nextStep();
                }
                clickCount = 0;
            }, 200);
        }
    }
    const back = (event) => {
        event.preventDefault();
        clickCount++;
        if (clickCount < 2) {
            setTimeout(() => {
                if (clickCount <= 1) {
                    props.prevStep();
                }
                clickCount = 0;
            }, 200);
        }
    }
    return (
        <React.Fragment>
            <Typography variant="h6" component="h6" className="navi-title">
                物件所在地は？
            </Typography>
            <div className="navi-description">
                <FormControl component="fieldset">
                    <RadioGroup className="navi-radio" aria-label="area" name="area" value={values.chartParam.area} >
                        <FormControlLabel value="" control={<Radio color="primary" onClick={next} />} label="指定しない" className="navi-radio-label" />
                        <FormControlLabel value="01" control={<Radio color="primary" onClick={next} />} label="北海道" className="navi-radio-label" />
                        <FormControlLabel value="02" control={<Radio color="primary" onClick={next} />} label="東北" className="navi-radio-label" />
                        <FormControlLabel value="03" control={<Radio color="primary" onClick={next} />} label="関東" className="navi-radio-label" />
                        <FormControlLabel value="04" control={<Radio color="primary" onClick={next} />} label="中部" className="navi-radio-label" />
                        <FormControlLabel value="05" control={<Radio color="primary" onClick={next} />} label="北陸" className="navi-radio-label" />
                        <FormControlLabel value="06" control={<Radio color="primary" onClick={next} />} label="近畿" className="navi-radio-label" />
                        <FormControlLabel value="07" control={<Radio color="primary" onClick={next} />} label="中国" className="navi-radio-label" />
                        <FormControlLabel value="08" control={<Radio color="primary" onClick={next} />} label="四国" className="navi-radio-label" />
                        <FormControlLabel value="09" control={<Radio color="primary" onClick={next} />} label="九州沖縄" className="navi-radio-label" />
                    </RadioGroup>
                </FormControl>
            </div>
            <Divider className="navi-divider" />
            <div className="navi-paging">
                <Button size="large" color="primary" onClick={back} startIcon={<ArrowBackIcon />}>戻る</Button>
            </div>
        </React.Fragment>
    )
}

export default FourthStep;
